
import TableList from "@components/templates/tablelist";
import { HttpGetCustomerList,HttpCancelCustomerOne,HttpActiveCustomerOne } from "@/service/manage/manage";

import comIndex from './update'
import { mapState,mapGetters } from "vuex";
export default {
    mixins: [TableList],
    components:{
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
            erpSkusList:[],
        };
    },
    methods: {
        ajaxRequest: HttpGetCustomerList,
        interceptRequest(params){
            delete params.search.createdAt;
            delete params.search.updatedAt;
            return params;
        },
        // 全部按钮点击操作
        handleOperates(params="", type,batch) {
            if(batch){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'customerupdate',
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'customerupdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title:this.$t('global.common.query',{defaultValue:'查看'}),
                        show:true,
                        width:1200,
                        showFooter:false,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query'
                    }
                    break;
                case "disable":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{id:params},
                        title: this.$t('erp.b2border.stopping',{defaultValue:'停用操作'}),
                        ajaxRequest:HttpCancelCustomerOne
                    }
                    break;
                case "active":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{id:params},
                        title: this.$tc("global.common.activeing",1,{defaultValue:'启用操作'}),
                        ajaxRequest:HttpActiveCustomerOne
                    }
                    break;
            }
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row){
            const { id, active } = row
            return [{
                label:this.$t('global.common.query',{defaultValue:'查看'}),
                show:true,
                params:id,
                operate:'query'
            },{
                label:this.$t('global.common.edit',{defaultValue:'编辑'}),
                show:true,
                params:id,
                operate:'edit'
            },{
                label:this.$tc("global.common.inactive",2,{defaultValue:'停用'}),
                show:active=='Y',
                params:id,
                operate:'disable'
            },
            {
                label:this.$tc("global.common.activeing",2,{defaultValue:'启用'}),
                show:active=='N',
                params:id,
                operate:'active'
            }]
        },
        dedupe(array) {
			var temp = []; //一个新的临时数组
			for(var i = 0; i < array.length; i++){
				if(temp.indexOf(array[i]) == -1){
					temp.push(array[i]);
				}
			}
			return temp;
		},
    },
    computed: {
        ...mapState('boss', ['accounts']),
        ...mapGetters('diction',['getAllSalesList']),
        // table中单据状态的按钮展示
        orderStatus(){
            return [
                {
                    value: '0',
                    label: this.$t("global.common.effective",{defaultValue:'有效'}),
                    theme:'info',
                },
                {
                    value: '1',
                    label: this.$t("global.common.failure",{defaultValue:'失效'}),
                    theme:'error',
                },
            ];
        },
        // 左边的批量操作按钮
        ToolsData(){
            return [
                {
                    name: this.$t("global.common.add",{defaultValue:'添加'}),
                    operate: "add",
                    theme: "primary",
                },
            ]
        },
        // 搜索下拉框展示内容
        SearchsData() {
            const dropStyle="width:auto;min-width:200px;";
            let arrayList=[],channelTypeList;
			for(let i=0;i<this.accounts.length;i++){
				arrayList.push(this.accounts[i].type)
			}
			channelTypeList = this.dedupe(arrayList)
            return  [
                {
                    label: this.$t("global.common.customerId",{defaultValue:'客户ID'}),
                    tag: 'vInput',
                    key: 'EQ_id',
                    show:true,
                },
                {
                    label: this.$t("erp.b2border.customerName",{defaultValue:'客户姓名'}),
                    tag: 'vInput',
                    key: 'CN_customerName',
                    show:true
                },
                {
                    label: this.$t("erp.b2c.customers_email",{defaultValue:'邮箱'}),
                    tag: 'vInput',
                    key: 'CN_email',
                    show:true
                },

                {
                    label: this.$t("global.common.isinactive",{defaultValue:'是否停用'}),
                    tag: 'vSelect',
                    key: 'EQ_active',
                    options: [
                        {
                            value: 'N',
                            label: this.$t("erp.global.yes",{defaultValue:'是'})
                        },
                        {
                            value: 'Y',
                            label: this.$t("erp.global.no",{defaultValue:'否'})
                        },
                    ],
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },

                {
                    label: this.$t("global.common.createdtime",{defaultValue:'创建时间'}),
                    tag: 'DatePicker',
                    key:'createdAt',
                    props:{
                        type:"daterange",
                        format:'yyyy-MM-dd',
                        confirm:false,
                    },
                    style: "width:180px",
                    on:{
                        'on-change':(val1)=>{
                            if(val1[0]!==''){
                                this.formData.search.BT_createdAt = val1[0] + ' ~ ' + val1[1]
                            }else{
                                this.formData.search.BT_createdAt = ''
                            }
                        }
                    }
                },
                {
                    label: this.$t("global.common.update_time",{defaultValue:'更新时间'}),
                    tag: 'DatePicker',
                    key:'updatedAt',
                    props:{
                        type:"daterange",
                        format:'yyyy-MM-dd',
                        confirm:false,
                    },
                    style: "width:180px",
                    on:{
                        'on-change':(val2)=>{
                            if(val2[0]!==''){
                                this.formData.search.BT_updatedAt = val2[0] + ' ~ ' + val2[1]
                            }else{
                                this.formData.search.BT_updatedAt = ''
                            }
                        }
                    }
                },

            ]
        },
        // table的展示数据
        columns() {
            return  [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: this.$t("global.common.operation",{defaultValue:'操作'}),
                width: 90,
                render:this.getOperateNodes
            },
            {
                title: this.$t("erp.b2border.customerid_name",{defaultValue:'客户ID/姓名'}),
                render:(h,{row})=>{
                    return <div>
                        <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.id}</a>
                        </div>
                        <div>{row.customerName}</div>
                    </div>
                }
            },

            {
                title: this.$t("global.common.isinactive",{defaultValue:'是否停用'}),
                key: 'active',
                render:(h,{row})=>{
                    switch(row.active){
                        case 'N': return <div>{this.$t("erp.global.yes",{defaultValue:'是'})}</div> ; break;
                        case 'Y': return <div>{this.$t("erp.global.no",{defaultValue:'否'})}</div> ; break;
                    }

                },
            },
            {
                title: this.$t("erp.b2c.customers_email",{defaultValue:'邮箱'}),
                render:(h,{row})=>{
                    return <div>{row.email}</div>
                }
            },
            {
                title: this.$t("erp.b2border.salesman",{defaultValue:'销售员姓名'}),
                render:(h,{row})=>{
                    const saleid = row.salespersonId;
                    const saleitem = this.getAllSalesList.filter((item) => {
                        return saleid === item.value
                    })[0] || {};
                    // console.log(saleitem)
                    // getAllSalesList
                    return <div>{saleitem.label}</div>
                }
            },
            {
                title: this.$t("erp.b2border.customer_type",{defaultValue:'客户类型'}),
                maxWidth:120,
                render:(h,{row})=>{
                    return <div>{row.type}</div>
                }
            },
            {
                title: this.$t("global.common.created_updated",{defaultValue:'创建/更新时间'}),
                render:(h,{row})=>{
                    return <div>
                        <div>{row.createdAt}</div>
                        <div>{row.updatedAt}</div>
                    </div>
                }
            }
        ];
        },

    },
};
